import React from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import { logger } from './services/logger';
// Initialize Sentry error tracking (only in production if DSN is configured)
import './config/sentry';

// Safety measure: Disable console.log/debug/info in production
// This prevents any remaining console statements from executing overhead
// Note: We're migrating to logger service, but this provides a fallback
if (process.env.NODE_ENV === 'production') {
  // Override console methods to no-ops in production
  // Keep console.error and console.warn for critical issues (until fully migrated)
  const noop = () => {};
  /* eslint-disable no-console */
  console.log = noop;
  console.debug = noop;
  console.info = noop;
  /* eslint-enable no-console */
  // console.error and console.warn remain active for critical issues
}

logger.info('Starting app initialization');
const container = document.getElementById('root');
if (!container) {
  logger.error('Failed to find root element');
  throw new Error('Failed to find the root element');
}
logger.debug('Root element found');
const root = createRoot(container);
logger.debug('React root created');

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
logger.success('App component rendered');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.register({
  onUpdate: (registration) => {
    // Create a custom UI to notify the user of a new version
    const updateAvailable = document.createElement('div');
    updateAvailable.className = 'update-notification';
    updateAvailable.innerHTML = `
      <div class="update-inner">
        <p>A new version is available!</p>
        <button id="update-app">Update Now</button>
      </div>
    `;
    document.body.appendChild(updateAvailable);

    // Add click handler for the update button
    document.getElementById('update-app')?.addEventListener('click', () => {
      if (registration.waiting) {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      }
      window.location.reload();
    });
  },
  onSuccess: (_registration) => {
    logger.info('Successfully registered service worker for offline support');
  }
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals(); 